import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import PropTypes from 'prop-types'
import { withNamespaces } from 'react-i18next'
import 'material-symbols'

import LevelTag from '../LevelTag/LevelTag'
import './ProjectCard.scss'

const linkUrl = (locale, project) => {
  return `/${locale}/projects/${project.repositoryName}`
}

export const ProjectCard = ({ locale, project, t, gtm: { category } = {} }) => {
  const { pathways = [] } = project
  const {
    difficulty_level: difficultyLevel,
    technology_theme: technologyTheme,
  } = pathways[0] || {}
  const hasTags =
    project.content.software.length !== 0 ||
    project.content.hardware.length !== 0

  const sendDataToGTM = useGTMDispatch()
  const handleClick = () =>
    sendDataToGTM({
      category: category,
      label: 'Featured projects: any project',
    })

  return (
    <div className="c-project-card rpf-shadow-centre">
      <img
        className="c-project-card__image"
        src={project.content.heroImage}
        alt=""
      />
      <div className="c-project-card__content">
        <a
          className="c-project-card__heading"
          href={linkUrl(locale, project)}
          onClick={handleClick}
        >
          {project.content.title}
        </a>
        {project.content.pdf && (
          <div className="c-project-card__download">
            <a
              className="c-project-card__download-link"
              href={project.content.pdf}
              onClick={handleClick}
              target="_blank"
              rel="noreferrer"
            >
              <span className="material-symbols-outlined">download</span>
              <span className="c-project-card__download-text">
                {t('general.pdf')}
              </span>
            </a>
          </div>
        )}
        <p className="c-project-card__text">
          {project.content.description || ''}
        </p>
        {hasTags && (
          <ul className="c-project-card__tags">
            {project.content.software.map((tag, i) => {
              return (
                <li className="c-project-card__tag" key={i}>
                  {t(`filter.software.options.${tag}`)}
                </li>
              )
            })}
            {project.content.hardware.map((tag, i) => {
              return (
                <li className="c-project-card__tag" key={i}>
                  {t(`filter.hardware.options.${tag}`)}
                </li>
              )
            })}
          </ul>
        )}
        <LevelTag level={difficultyLevel} technology={technologyTheme} />
      </div>
    </div>
  )
}

ProjectCard.propTypes = {
  locale: PropTypes.string.isRequired,
  project: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  gtm: PropTypes.object,
}

export default withNamespaces('translations')(ProjectCard)
